import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column mt-2 card p-2" }
const _hoisted_2 = { class: "font-size-base fw-bold" }
const _hoisted_3 = { class: "mb-1 text-secondary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Contact Information:", -1 /* HOISTED */)
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "me-1" }
const _hoisted_7 = { class: "me-1" }
const _hoisted_8 = { class: "me-1" }
const _hoisted_9 = { class: "me-1" }
const _hoisted_10 = { class: "me-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, " Phone:", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Fax:", -1 /* HOISTED */)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "  Not Available", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.contactInformation.lastName) + ", " + _toDisplayString(_ctx.contactInformation.firstName), 1 /* TEXT */),
    _createElementVNode("span", _hoisted_3, " NPI: " + _toDisplayString(_ctx.contactInformation.npiNumber), 1 /* TEXT */),
    _hoisted_4,
    _createElementVNode("span", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.contactInformation?.address?.addressLine1), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.contactInformation?.address?.addressLine2), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.contactInformation?.address?.city), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.contactInformation?.address?.state), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.contactInformation?.address?.zipCode), 1 /* TEXT */)
    ]),
    _createElementVNode("span", null, [
      _hoisted_11,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactInformation.phoneNumbers, (phoneNumber, index) => {
        return (_openBlock(), _createElementBlock("span", { key: index }, "  " + _toDisplayString(phoneNumber.country) + "-" + _toDisplayString(phoneNumber.number) + _toDisplayString(index != _ctx.contactInformation.phoneNumbers.length - 1 ? "," : ""), 1 /* TEXT */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("span", null, [
      _hoisted_12,
      (_ctx.contactInformation.faxNumber)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.contactInformation.faxNumber), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("small", _hoisted_14, _hoisted_16))
    ]),
    _createElementVNode("span", null, _toDisplayString(_ctx.contactInformation.email), 1 /* TEXT */)
  ]))
}